/** Build links into the separately hosted member app from server-returned paths. */

/** Public member-app origin. Invitations are opened there, never on the admin host. */
export const MEMBER_APP_URL =
  import.meta.env.VITE_MEMBER_APP_URL?.trim() || "http://localhost:3002";

/** Resolve the opaque invitation path supplied by the API against the member origin. */
export function memberAppUrl(path: string): string {
  const base = MEMBER_APP_URL.endsWith("/")
    ? MEMBER_APP_URL
    : `${MEMBER_APP_URL}/`;
  return new URL(path, base).toString();
}
